import { render } from "./widget-header-main.vue?vue&type=template&id=23d0f375&scoped=true"
import script from "./widget-header-main.vue?vue&type=script&lang=js"
export * from "./widget-header-main.vue?vue&type=script&lang=js"

import "./widget-header-main.vue?vue&type=style&index=0&id=23d0f375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d0f375"]])

export default __exports__